var map = {
	"./": 18305,
	"./App": 8021,
	"./App.css": 93508,
	"./App.js": 8021,
	"./Assets/1 1.png": 46396,
	"./Assets/5.png": 72640,
	"./Assets/Allura Online Searching.png": 6803,
	"./Assets/Analythics.png": 31066,
	"./Assets/Contact-Us-(1).png": 20013,
	"./Assets/Contact_Us.png": 33934,
	"./Assets/Finance.png": 84433,
	"./Assets/Frame 5 (1).png": 22697,
	"./Assets/Frame 5 (2).png": 97495,
	"./Assets/Frame 5 (3).png": 11810,
	"./Assets/Frame 5 (4).png": 63909,
	"./Assets/Frame 5.png": 48164,
	"./Assets/Fresh Folk Teamwork.png": 27234,
	"./Assets/Group 42903.png": 20866,
	"./Assets/Group 42924.png": 63555,
	"./Assets/Money.png": 37068,
	"./Assets/Other 09.png": 58488,
	"./Assets/Other 17.png": 56082,
	"./Assets/Rectangle 373.png": 97606,
	"./Assets/Rectangle_373.png": 63915,
	"./Assets/Saly-13@2x.png": 71318,
	"./Assets/Saly-21.png": 46914,
	"./Assets/Saly-22.png": 18598,
	"./Assets/Saly-24.png": 85853,
	"./Assets/Saly-25.png": 7293,
	"./Assets/Saly-26 (1).png": 9617,
	"./Assets/Saly-26.png": 44451,
	"./Assets/Saly-31.png": 51664,
	"./Assets/Saly-42.png": 63236,
	"./Assets/Support.png": 46354,
	"./Assets/avatar3.png": 87169,
	"./Assets/empty.png": 2158,
	"./Assets/grad-bg.png": 88330,
	"./Assets/kemtech_header_img.png": 97971,
	"./Assets/logo.png": 42354,
	"./Assets/original-e0e275874b52009a537484d7785b9fa0 1.png": 72858,
	"./Assets/ps copy.png": 10691,
	"./Assets/ps.png": 17301,
	"./Assets/teetop.png": 73256,
	"./Assets/teetop1 (2).png": 73857,
	"./Assets/teetop1.png": 84304,
	"./Assets/x36.png": 2669,
	"./Assets/Сoding.png": 11278,
	"./Components": 28829,
	"./Components/": 28829,
	"./Components/Bundle": 71990,
	"./Components/Bundle/": 71990,
	"./Components/Bundle/index": 71990,
	"./Components/Bundle/index.jsx": 71990,
	"./Components/Charts": 38990,
	"./Components/Charts.jsx": 38990,
	"./Components/Converter": 67514,
	"./Components/Converter.jsx": 67514,
	"./Components/Dashboard": 83516,
	"./Components/Dashboard.jsx": 83516,
	"./Components/DefaultHeader": 40263,
	"./Components/DefaultHeader.js": 40263,
	"./Components/ErrorPage": 36594,
	"./Components/ErrorPage.jsx": 36594,
	"./Components/Footer": 69229,
	"./Components/Footer.jsx": 69229,
	"./Components/Header": 4615,
	"./Components/Header.jsx": 4615,
	"./Components/Notification": 83727,
	"./Components/Notification.jsx": 83727,
	"./Components/Products": 93100,
	"./Components/Products/": 93100,
	"./Components/Products/airtime": 59763,
	"./Components/Products/airtime.js": 59763,
	"./Components/Products/data": 81050,
	"./Components/Products/data-pin": 20435,
	"./Components/Products/data-pin.js": 20435,
	"./Components/Products/data.js": 81050,
	"./Components/Products/electricity-bills": 17782,
	"./Components/Products/electricity-bills.js": 17782,
	"./Components/Products/index": 93100,
	"./Components/Products/index.jsx": 93100,
	"./Components/Products/tv-subscriptions": 3190,
	"./Components/Products/tv-subscriptions.js": 3190,
	"./Components/Settings": 14750,
	"./Components/Settings.jsx": 14750,
	"./Components/Sidebar": 54347,
	"./Components/Sidebar.jsx": 54347,
	"./Components/Transactions": 12634,
	"./Components/Transactions/": 12634,
	"./Components/Transactions/index": 12634,
	"./Components/Transactions/index.jsx": 12634,
	"./Components/Users": 82472,
	"./Components/Users/": 82472,
	"./Components/Users/index": 82472,
	"./Components/Users/index.jsx": 82472,
	"./Components/Wallets": 17522,
	"./Components/Wallets/": 17522,
	"./Components/Wallets/index": 17522,
	"./Components/Wallets/index.jsx": 17522,
	"./Components/index": 28829,
	"./Components/index.js": 28829,
	"./Data/Actions/ActionTypes": 72781,
	"./Data/Actions/ActionTypes.js": 72781,
	"./Data/Actions/AuthActions": 42493,
	"./Data/Actions/AuthActions.js": 42493,
	"./Data/Config": 1669,
	"./Data/Config.js": 1669,
	"./Data/Context": 70695,
	"./Data/Context.js": 70695,
	"./Data/Reducer": 61634,
	"./Data/Reducer/": 61634,
	"./Data/Reducer/AirtimeReducer": 4840,
	"./Data/Reducer/AirtimeReducer.js": 4840,
	"./Data/Reducer/AuthReducer": 87841,
	"./Data/Reducer/AuthReducer.js": 87841,
	"./Data/Reducer/CableReducer": 43772,
	"./Data/Reducer/CableReducer.js": 43772,
	"./Data/Reducer/DataReducer": 95328,
	"./Data/Reducer/DataReducer.js": 95328,
	"./Data/Reducer/ElectricityReducer": 94578,
	"./Data/Reducer/ElectricityReducer.js": 94578,
	"./Data/Reducer/ErrorReducer": 7202,
	"./Data/Reducer/ErrorReducer.js": 7202,
	"./Data/Reducer/NetworkPlanReducer": 64338,
	"./Data/Reducer/NetworkPlanReducer.js": 64338,
	"./Data/Reducer/index": 61634,
	"./Data/Reducer/index.js": 61634,
	"./Data/Store": 50066,
	"./Data/Store.js": 50066,
	"./PageRender": 77839,
	"./PageRender.jsx": 77839,
	"./Pages/bundles": 20075,
	"./Pages/bundles.jsx": 20075,
	"./Pages/converter": 26664,
	"./Pages/converter.jsx": 26664,
	"./Pages/dashboard": 36904,
	"./Pages/dashboard.jsx": 36904,
	"./Pages/home": 34030,
	"./Pages/home.jsx": 34030,
	"./Pages/notifications": 97243,
	"./Pages/notifications.jsx": 97243,
	"./Pages/products": 87822,
	"./Pages/products/": 87822,
	"./Pages/products/airtime": 48136,
	"./Pages/products/airtime.js": 48136,
	"./Pages/products/data": 54233,
	"./Pages/products/data-pin": 39387,
	"./Pages/products/data-pin.js": 39387,
	"./Pages/products/data.js": 54233,
	"./Pages/products/electricity-bills": 12544,
	"./Pages/products/electricity-bills.js": 12544,
	"./Pages/products/index": 87822,
	"./Pages/products/index.jsx": 87822,
	"./Pages/products/tv-subscriptions": 98034,
	"./Pages/products/tv-subscriptions.js": 98034,
	"./Pages/settings": 29195,
	"./Pages/settings.jsx": 29195,
	"./Pages/transactions": 56433,
	"./Pages/transactions/": 56433,
	"./Pages/transactions/index": 56433,
	"./Pages/transactions/index.jsx": 56433,
	"./Pages/wallets": 10308,
	"./Pages/wallets/": 10308,
	"./Pages/wallets/bonus": 25465,
	"./Pages/wallets/bonus.jsx": 25465,
	"./Pages/wallets/commissions": 46767,
	"./Pages/wallets/commissions.jsx": 46767,
	"./Pages/wallets/index": 10308,
	"./Pages/wallets/index.jsx": 10308,
	"./Routes": 65227,
	"./Routes.jsx": 65227,
	"./Screens/about": 96426,
	"./Screens/about/": 96426,
	"./Screens/about/index": 96426,
	"./Screens/about/index.jsx": 96426,
	"./Screens/activate": 94551,
	"./Screens/activate.jsx": 94551,
	"./Screens/blogs": 33750,
	"./Screens/blogs/": 33750,
	"./Screens/blogs/index": 33750,
	"./Screens/blogs/index.jsx": 33750,
	"./Screens/contact": 8369,
	"./Screens/contact/": 8369,
	"./Screens/contact/index": 8369,
	"./Screens/contact/index.jsx": 8369,
	"./Screens/forget-password": 98533,
	"./Screens/forget-password.jsx": 98533,
	"./Screens/home": 55255,
	"./Screens/home.jsx": 55255,
	"./Screens/login": 82215,
	"./Screens/login.jsx": 82215,
	"./Screens/register": 222,
	"./Screens/register.jsx": 222,
	"./Screens/services": 46117,
	"./Screens/services/": 46117,
	"./Screens/services/index": 46117,
	"./Screens/services/index.jsx": 46117,
	"./Styles/Sidebar.css": 64788,
	"./Utils": 71510,
	"./Utils/": 71510,
	"./Utils/index": 71510,
	"./Utils/index.jsx": 71510,
	"./Views/administration": 62090,
	"./Views/administration/": 62090,
	"./Views/administration/admins": 75119,
	"./Views/administration/admins.jsx": 75119,
	"./Views/administration/employees": 85767,
	"./Views/administration/employees.jsx": 85767,
	"./Views/administration/index": 62090,
	"./Views/administration/index.jsx": 62090,
	"./Views/bundles": 22046,
	"./Views/bundles.jsx": 22046,
	"./Views/controls": 85988,
	"./Views/controls/": 85988,
	"./Views/controls/broadcasts": 95628,
	"./Views/controls/broadcasts.jsx": 95628,
	"./Views/controls/index": 85988,
	"./Views/controls/index.jsx": 85988,
	"./Views/controls/tv-subscriptions": 56961,
	"./Views/controls/tv-subscriptions.jsx": 56961,
	"./Views/converter": 17510,
	"./Views/converter.jsx": 17510,
	"./Views/dashboard": 1043,
	"./Views/dashboard.jsx": 1043,
	"./Views/home": 242,
	"./Views/home.jsx": 242,
	"./Views/notifications": 36013,
	"./Views/notifications.jsx": 36013,
	"./Views/products": 79144,
	"./Views/products/": 79144,
	"./Views/products/airtime": 52611,
	"./Views/products/airtime.js": 52611,
	"./Views/products/data": 27953,
	"./Views/products/data-pin": 19212,
	"./Views/products/data-pin.js": 19212,
	"./Views/products/data.js": 27953,
	"./Views/products/electricity-bills": 99457,
	"./Views/products/electricity-bills.js": 99457,
	"./Views/products/index": 79144,
	"./Views/products/index.jsx": 79144,
	"./Views/products/tv-subscriptions": 28089,
	"./Views/products/tv-subscriptions.js": 28089,
	"./Views/reports": 78215,
	"./Views/reports/": 78215,
	"./Views/reports/index": 78215,
	"./Views/reports/index.jsx": 78215,
	"./Views/settings": 29020,
	"./Views/settings.jsx": 29020,
	"./Views/transactions": 78027,
	"./Views/transactions/": 78027,
	"./Views/transactions/add": 9224,
	"./Views/transactions/add.jsx": 9224,
	"./Views/transactions/index": 78027,
	"./Views/transactions/index.jsx": 78027,
	"./Views/users": 43241,
	"./Views/users/": 43241,
	"./Views/users/index": 43241,
	"./Views/users/index.jsx": 43241,
	"./Views/wallets": 85735,
	"./Views/wallets/": 85735,
	"./Views/wallets/bonus": 51488,
	"./Views/wallets/bonus.jsx": 51488,
	"./Views/wallets/commissions": 33043,
	"./Views/wallets/commissions.jsx": 33043,
	"./Views/wallets/index": 85735,
	"./Views/wallets/index.jsx": 85735,
	"./index": 18305,
	"./index.css": 51174,
	"./index.js": 18305,
	"./logo.svg": 31100,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;